import { dateTimeFormat } from '@/utility/utility_functions'
import FormData from '@/classes/form/FormData'
import FormDescriptor from '@/classes/form/FormDescriptor'
import { Document } from '@/classes/case/Document'
import Profile from '@/classes/auth/Profile'

export default class Report {
  constructor (id, caseId, casePk, certificateId, periodStartDate, periodEndDate, isReported, inProgress, reportedDate, reportComment, reportBlankReason, reportedBy, document) {
    this.id = id
    this.caseId = caseId
    this.casePk = casePk
    this.certificateId = certificateId
    this.periodStartDate = periodStartDate
    this.periodEndDate = periodEndDate
    this.isReported = isReported
    this.inProgress = inProgress
    this.reportDate = reportedDate
    this.reportComment = reportComment
    this.reportBlankReason = reportBlankReason
    this.reportedBy = reportedBy
    this.formDescriptors = null
    this.formDatas = null
    this.document = document
  }

  static asReports (json) {
    return json.map(jsonReport => {
      return Report.asReport(jsonReport)
    })
  }

  static asReport (json) {
    return new Report(
      json.id,
      json.case_id,
      json.case_pk,
      json.certificate,
      json.period_start_date ? dateTimeFormat(json.period_start_date) : '',
      json.period_end_date ? dateTimeFormat(json.period_end_date) : '',
      json.is_completed,
      json.in_progress,
      json.reported_date ? dateTimeFormat(json.reported_date) : '',
      json.report_comment,
      json.report_blank_reason,
      json.reported_by ? Profile.asProfile(json.reported_by) : null,
      json.document ? Document.asDocument(json.document) : []

    )
  }

  updateReport (json) {
    this.caseId = json.case_id
    this.casePk = json.case_pk
    this.certificateId = json.certificate
    this.isReported = json.is_completed
    this.inProgress = json.in_progress
    this.periodStartDate = json.period_start_date ? dateTimeFormat(json.period_start_date) : ''
    this.periodEndDate = json.period_end_date ? dateTimeFormat(json.period_end_date) : ''
    this.reportDate = json.reported_date ? dateTimeFormat(json.reported_date) : ''
    this.reportComment = json.report_comment
    this.reportBlankReason = json.report_blank_reason
  }

  get self () {
    return { item: this }
  }

  get periodDate () {
    return `${this.periodStartDate} - ${this.periodEndDate}`
  }

  get filesComponent () {
    return { files: this.document.files }
  }

  get caseLink () {
    return {
      name: 'CaseView',
      params: { caseId: this.casePk }
    }
  }

  setFormDescriptors (data) {
    this.formDescriptors = FormDescriptor.asFormDescriptors(data)
  }

  setFormDatas (data) {
    this.formDatas = FormData.initiateFormDatas(this.formDescriptors)
    FormData.loadInitialFormDatas(data, this.formDatas)
    FormDescriptor.checkFormDescriptorsDependencies(this.formDescriptors, this.formDatas)
  }
}
